<template>
    <v-card class="elevation-12">
        <v-toolbar dark color="primary">
            <v-toolbar-title>{{title}}:</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
            <v-form >
                <v-layout row wrap >
                    <v-flex >
                        <v-select
                                :label=label
                                single-line
                                prepend-icon="people"
                                item-value=id
                                item-text=name
                                :items="items"
                                v-model="selectedItem"
                                outline
                        >
                        </v-select>
                    </v-flex>
                </v-layout>
            </v-form>
        </v-card-text>
        <v-card-actions v-if="hasbtn">
            <v-layout column>
                <v-btn color="primary" @click="onsubmit(selectedItem)" >{{btnLabel}}</v-btn>
            </v-layout>
        </v-card-actions>
    </v-card>
</template>

<script>
    export default {
        name: "select-and-submit",
        props: ['title', 'label', 'btn-label', 'items', 'onsubmit', 'hasbtn'],
        data () {
            return {
                selectedItem: null,
                url: "https://httpbin.org/post"
            }
        }
    }
</script>
<style>
</style>